export default __webpack_public_path__ + "static/media/funfacts_icon_black.c049c157.svg";